module.exports = __webpack_public_path__ + "img/default-app.5f239a95.svg";